import { Box, styled } from '@mui/material';

const PREFIX = 'TSMED-HubsReportPreview';

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
})(() => ({
  display: 'flex',
  borderRadius: 'inherit',
}));

export const HubsReportPreview = () => (
  <Root>
    <img
      style={{ borderRadius: 'inherit', pointerEvents: 'none' }}
      src="/hub-report.png"
      alt="Hubs Report"
      width={195}
      height={145}
    />
  </Root>
);
